import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { commonMessages } from 'src/utils/messages';
import { UnitFormSchemaValues } from 'src/features/units/utils/formSchema';
import { unitsMessages } from 'src/features/units/utils/messages';

type UnitFormProps = {
    form: UseFormReturn<UnitFormSchemaValues>;
    onSubmit: (values: UnitFormSchemaValues) => void;
};

function UnitForm({ onSubmit, form }: UnitFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<UnitFormSchemaValues> form={form} name="name" label={formatMessage(commonMessages.name)} />
            <InputFormField<UnitFormSchemaValues>
                form={form}
                name="abbreviation"
                label={formatMessage(unitsMessages.abbreviation)}
            />
            <InputFormField<UnitFormSchemaValues> form={form} name="code" label={formatMessage(unitsMessages.code)} />
        </Form>
    );
}

export default UnitForm;
